import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/LandingPage.css";
import Profile from "../components/img/transparentProfilePicture.png";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 500, // Animation duration in milliseconds
      offset: 200, // Trigger animation when 200px from the top
      easing: "ease-in-out", // Animation easing function
      once: true, // Animation runs only once
      mirror: true, // Animation plays again when scrolling back up
    });
  }, []);

  return (
    <div className="landingPage">
      <div className="introName" data-aos="fade-up">
        <div className="myName">I am Vladislav,</div>
        <div className="specialization">Software Developer</div>
      </div>
      <div className="introCode" data-aos="fade-up" data-aos-delay="500">
        I work with&nbsp;
        <span className="rollingWords">
          <span className="rollingWord">React</span>
          <span className="rollingWord">React Native</span>
          <span className="rollingWord">Jetpack Compose</span>
          <span className="rollingWord">Angular</span>
        </span>
      </div>
      <div
        className="introBrief"
        data-aos="fade-up"
        data-aos-delay="1000"
        data-aos-offset="100"
      >
        I am qualified IT specialist working in Web and Mobile development. My
        passion is innovation and problem-solving. I like to contribute to the
        software development and enjoy continuously learning and exploring new
        technologies.
      </div>
      <img
        src={Profile}
        alt="Vladislav Pogudin"
        className="introImage"
        data-aos="fade-up"
        data-aos-delay="1500"
      />
    </div>
  );
};

export default LandingPage;
